export default __webpack_public_path__ + "static/media/frontend-cards.26afb969.mp4";